import { Component } from '@angular/core';

@Component({
  selector: 'ngx-shipping-widget',
  templateUrl: './shipping-widget.component.html',
  styleUrls: ['./shipping-widget.component.scss']
})
export class ShippingWidgetComponent {
  constructor(){}
}
